import en from './en';
import fr from './fr';

export default {
    en,
    fr,
};